import React from 'react';
import { ArticleSection } from './ArticleSection';
import { ExternalLink } from '../ExternalLink';
import { contextualLinks } from '../../data/site';
export function CustomerSupportSection() {
  const link = contextualLinks.chatbotUsa;
  return <ArticleSection id="customer-support" title="Customer Support Automation and AI Chatbots" data-id="element-64" data-mp="2r51k27jc0r32">
      <p data-id="element-65" data-mp="2w6qvhoagv6ro">
        Customer support is often where organisations see value first, because volumes are high and many
        requests follow recognisable patterns. A well-built support workflow does far more than answer
        FAQs. It identifies intent, retrieves the right order or account details, resolves routine requests
        end to end and hands complex or emotional cases to a person with a clear summary attached.
      </p>
      <p data-id="element-66" data-mp="3jva27zdvbbhn">
        Judge chatbots and voice agents on the quality of what they resolve, not just how many
        conversations they close. A bot that ends tickets by wearing customers down is not saving money;
        it is moving the cost into churn and complaints.
      </p>
      <ul className="bullets" data-id="element-67" data-mp="ds2wtdf4z38g">
        <li data-id="element-68" data-mp="8utcgc6lthrh">Answers grounded in approved knowledge sources, not the model’s general memory.</li>
        <li data-id="element-69" data-mp="3vq4ojz8oxft">Seamless handover to a human, with the full conversation and context carried across.</li>
        <li data-id="element-70" data-mp="3v32mn17y5ews">Clear disclosure that customers are talking to an automated assistant.</li>
        <li data-id="element-71" data-mp="wknmyn3gau8k">Regular review of transcripts to catch gaps in knowledge or tone.</li>
      </ul>
      <p data-id="element-72" data-mp="rlu7ip4lst5r">
        If you are comparing conversational AI vendors across markets, this overview of{' '}
        <ExternalLink href={link.href} data-id="element-73" data-mp="mv4076cmag8f">{link.anchor}</ExternalLink> is a useful reference point alongside the
        UK providers above.
      </p>
    </ArticleSection>;
}